require("./sitio");
require("bootstrap");
require("@fancyapps/fancybox");
require("@fancyapps/fancybox/dist/jquery.fancybox.css");

require("./promo_webpay");
require("./flotante_cotizador");

require("leaflet");
require("leaflet/dist/leaflet.css");

import '@splidejs/splide/dist/css/splide.min.css';
const Splide = require('@splidejs/splide').default;

// scroll marca menu
function onScroll(event) {
    var scrollPos = $(document).scrollTop();
    $("#menu-extendido .scroll-to").each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));
        if (
            refElement.position().top - 100 <= scrollPos &&
            refElement.position().top + refElement.height() > scrollPos
        ) {
            $("#menu-extendido .scroll-to").removeClass("active");
            currLink.addClass("active");
        } else {
            // currLink.removeClass("active");
        }
    });
}
$(document).on("scroll", onScroll);

// mapa
if (mapa_centro.length && mapa_punto.length) {
    var mymap = L.map("mapid", {
        scrollWheelZoom: false,
    }).setView(mapa_centro, 15);

    var icon = L.icon({
        iconUrl: "../images/proyecto-depto/marker.png",
        shadowUrl: "",

        iconSize: [25, 41], // size of the icon
        shadowSize: [0, 0], // size of the shadow
        iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
        shadowAnchor: [4, 62], // the same for the shadow
        popupAnchor: [0, -40], // point from which the popup should open relative to the iconAnchor
    });

    var marker = L.marker(mapa_punto, { icon: icon })
        .addTo(mymap)
        .bindPopup(mapa_texto)
        .openPopup();

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '&copy; <a href="https://openstreetmap.org/copyright">baluart.cl</a>'
    }).addTo(mymap);


    mymap.on("click", function (e) {
        var coord = e.latlng.toString().split(",");
        var lat = coord[0].split("(");
        var lng = coord[1].split(")");
        console.log("" + lat[1] + ", " + lng[0]);
    });
}

require("./proyecto_casa_OLD");
require("./proyecto_townhouse");
require("./proyecto_depto");
$(document).ready(function () {
    $(`.${borrar_clase}`).remove();
});

require("./components/FormularioProyecto");
